/* eslint-disable react-hooks/exhaustive-deps */
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";

function MomSysSelectNonStandardMaterial ( props ) {

    const {
        materialName,
        orderBuyerId,
        onInitialized,
        onLoadData,
        shipQty
    } = props;

    const [detailRefresh, setDetailRefresh] = useState();
    
    
    const { t } = useTranslation ();

    useEffect(()=>{

        if ( detailRefresh ) {

            detailRefresh.refresh ();

        }

    },[materialName, orderBuyerId, shipQty])

    const onApiInitialized = ( api ) => {

        setDetailRefresh ( api );

    };


    return (
        <BasicCrudScreenType 
            id="MomSysNsZvwMaterialOutputSgtWipLot"
            view="MomSysNsZvwMaterialOutputSgtWipLot"
            headerTitle={t("term.nonStandardShipPossibleLot")}
            onInitialized = {onInitialized}
            onApiInitialized={onApiInitialized}
            onModifyViewUrl = {(url) => `${url}/${orderBuyerId}/${materialName}`}
            noCreate
            noEdit
            noDelete
            noExcel
            onLoadData = {onLoadData}
            embededInOtherScreenType
        />
    )

}

export default MomSysSelectNonStandardMaterial;
